/**
 * Detects and collapses repeated word segments in a label.
 * e.g. "Alaska Bible Institute Alaska Bible Institute" → "Alaska Bible Institute"
 *      "Garden City Community College Garden City Community College" → "Garden City Community College"
 */
export function normalizeRepeatedLabel(text: string | null | undefined): string {
  if (!text) return ''
  const trimmed = text.trim()
  if (!trimmed) return ''

  const len = trimmed.length
  // Try splitting at the midpoint for 2x repeats
  if (len % 2 === 0) {
    const half = len / 2
    const a = trimmed.slice(0, half).trimEnd()
    const b = trimmed.slice(half).trimStart()
    if (a === b) return a
  }

  // Try word-level detection for segments that repeat with spacing differences
  const words = trimmed.split(/\s+/)
  const wc = words.length
  if (wc >= 2 && wc % 2 === 0) {
    const half = wc / 2
    const first = words.slice(0, half).join(' ')
    const second = words.slice(half).join(' ')
    if (first === second) return first
  }

  return trimmed
}
